import React from 'react';
import { IIconProps } from './IIconProps';

export const NoDataIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 74 74"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M0.754395 15.2697L1.06516 15.1694M0.754395 15.2697V57.7675C0.754395 58.6896 1.50756 59.4372 2.43663 59.4372H34.8197M0.754395 15.2697V2.66963C0.754395 1.74752 1.50756 1 2.43663 1H43.6514C44.5805 1 45.3336 1.74752 45.3336 2.66963V33"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<line
				x1="11"
				y1="26.5"
				x2="37"
				y2="26.5"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<path
				d="M18 20L27.6739 11.0016M28 19.9984L18.3261 11"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<line
				x1="11"
				y1="34.5"
				x2="17"
				y2="34.5"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<line
				x1="11"
				y1="42.5"
				x2="23"
				y2="42.5"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<line
				x1="11"
				y1="49.5"
				x2="14"
				y2="49.5"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<line
				x1="17"
				y1="49.5"
				x2="22"
				y2="49.5"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<line
				x1="23"
				y1="34.5"
				x2="32"
				y2="34.5"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<path
				d="M62.5 50.5C62.5 57.1274 57.1274 62.5 50.5 62.5C43.8726 62.5 38.5 57.1274 38.5 50.5C38.5 43.8726 43.8726 38.5 50.5 38.5C57.1274 38.5 62.5 43.8726 62.5 50.5Z"
				stroke="#000733"
				strokeOpacity="0.16"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M63 50.5C63 57.4036 57.4036 63 50.5 63C43.5964 63 38 57.4036 38 50.5C38 43.5964 43.5964 38 50.5 38C57.4036 38 63 43.5964 63 50.5ZM60.4075 66.1262C57.5433 67.946 54.1447 69 50.5 69C40.2827 69 32 60.7173 32 50.5C32 40.2827 40.2827 32 50.5 32C60.7173 32 69 40.2827 69 50.5C69 54.6058 67.6625 58.3991 65.3995 61.4682L72.0786 68.1126C73.4147 69.4416 73.3979 71.5794 72.0412 72.8873C70.6845 74.1953 68.5016 74.1782 67.1655 72.8491L60.4075 66.1262Z"
				fill="#000733"
				fillOpacity="0.08"
			/>
		</svg>
	);
};
